module.exports = __webpack_public_path__ + "static/img/sjyy.4f70208.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sjyy.png
// module id = NVof
// module chunks = 0